module.exports = __webpack_public_path__ + "static/media/runny_nose.2213aa01.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms/runny_nose.png
// module id = 414
// module chunks = 0